import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const StatCard = ({ title, count, icon, colour }) => {
    return (
        <Card className={cn("p-5 shadow-md hover:shadow-lg transition-shadow")} style={{ backgroundColor: colour }}>
            <CardContent className="p-0">
                <Stack spacing="sm" align="start">
                    <img className="w-12 h-12 object-contain" src={icon} alt={title} />
                    <div>
                        <Heading level="h3" className="text-lg font-semibold mb-1">{title}</Heading>
                        <Text className="text-2xl font-bold">{count}</Text>
                    </div>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default StatCard;